// src/components/DownloadButton.jsx
import React, { useState, useRef } from "react";

const DownloadButton = ({ project }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isCanceled, setIsCanceled] = useState(false);
  const xhrRef = useRef(null);

  const handleDownload = () => {
    setIsDownloading(true);
    setProgress(0);
    setIsCanceled(false);

    const xhr = new XMLHttpRequest();
    xhrRef.current = xhr;

    xhr.open(
      "GET",
      `http://localhost:3001/download-zip?project=${project}`,
      true
    );
    xhr.responseType = "blob";

    xhr.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentage = Math.round((event.loaded / event.total) * 100);
        setProgress(percentage);
      }
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        const url = window.URL.createObjectURL(new Blob([xhr.response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "download.zip");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
      resetDownload();
    };

    xhr.onerror = () => {
      console.error("An error occurred during the download.");
      resetDownload();
    };

    xhr.send();
  };

  const resetDownload = () => {
    setIsDownloading(false);
    setProgress(0);
    setIsCanceled(false);
    xhrRef.current = null;
  };

  const handleCancel = () => {
    if (xhrRef.current) {
      xhrRef.current.abort();
      setIsCanceled(true);
    }
    resetDownload();
  };

  return (
    <div>
      {isDownloading ? (
        <button
          onClick={handleCancel}
          className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition duration-300"
        >
          Cancel ({progress}%)
        </button>
      ) : (
        <button
          onClick={handleDownload}
          className="duration-300 hover:bg-yellow-700 border border-yellow-800 hover:text-white bg-yellow-500 font-semibold text-yellow-900 px-3 py-2 flex flex-row items-center gap-3 rounded-md"
        >
          Download
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            className="fill-current"
            viewBox="0 0 20 20"
          >
            <path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
          </svg>
        </button>
      )}
      {isCanceled && <p className="text-red-500 mt-2">Download canceled.</p>}
    </div>
  );
};

export default DownloadButton;
